export const Decode = function (data)
{
    return process.env.APP_BASE64 ? JSON.parse(atob(data)) : data;
};



// WEBPACK FOOTER //
// ./src/utils/decode.js